module.exports = __webpack_public_path__ + "static/media/p-2.76ec7b9d.png";